import React from 'react';
import { DataTable } from 'carbon-components-react';
import { CheckmarkOutline24, MisuseAlt24 } from '@carbon/icons-react';
import OverflowMenuCell from './OverflowMenuCell';

const {
  TableContainer,
  Table,
  TableExpandHeader,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableHeader
} = DataTable;

const NestedDataTable = ({ id, rawData, headers, removeHeaders, keyName, allowEdit, onEdit, onDelete }) => {
  const rows = rawData
    .find(e => e.id === id.toString())[keyName]
    .map((row, i) => (
      {
        id: i.toString(),
        ...row
      }
    ));

  function parseCellValue (value) {
    let type = typeof value;
    type = type === 'object' && Array.isArray(value) ? 'array' : type;
    switch (type) {
      case 'undefined':
        return '';
      case 'array':
        return value.join(', ');
      case 'boolean':
        return value ? <CheckmarkOutline24 fill='#3DBB61' /> : <MisuseAlt24 fill='#FB4B53' />;
      default:
        return value ? value.toString() : '';
    }
  }

  return (
    <DataTable
      headers={headers}
      rows={rows}
      size='short'
      render={({ headers, rows, getHeaderProps }) => (
        <TableContainer className='nested-data-table'>
          <Table>
            {!removeHeaders && (
              <TableHead>
                <TableRow>
                  <TableExpandHeader />
                  {headers.map((header, i) => (
                    <TableHeader
                      key={i}
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      {...getHeaderProps({ header })}
                    >
                      {header.header}
                    </TableHeader>
                  ))}
                  {allowEdit && (<TableHeader style={{ width: '5%' }} />)}
                </TableRow>
              </TableHead>
            )}
            <TableBody>
              {rows.map((row, i) => (
                <TableRow key={i}>
                  <td className='bx--table-expand' />
                  {row.cells.map((cell, i) => (
                    <TableCell key={cell.id}><span className='data-table_cell-value'>{parseCellValue(cell.value)}</span></TableCell>
                  ))}
                  {allowEdit && (<OverflowMenuCell id={row.id} onEdit={onEdit} onDelete={onDelete} />)}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    />
  );
};

export default NestedDataTable;
